import AxiosClient from "../../../services/axios.services";

class TrainingServices {
  getTraining = (params) =>
    AxiosClient.get("/api/app/descriptor_perfil_formacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getTrainingById = (id) =>
    AxiosClient.get(`/api/app/descriptor_perfil_formacion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });

  saveTraining = (data) =>
    AxiosClient.post("/api/app/descriptor_perfil_formacion/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editTraining = (id, data) =>
    AxiosClient.put(`/api/app/descriptor_perfil_formacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteTraining = (id) =>
    AxiosClient.delete(`/api/app/descriptor_perfil_formacion/${id}`, {
      headers: { "Content-Type": "aplication/json" },
    });
}

export default new TrainingServices();
